<template>
	<!-- Footer component -->
	<footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-6">
					{{ new Date().getFullYear() }} © Lalamove+
					{{
						appEnv !== 'prd' ? '(' + appEnv.toUpperCase() + ')' : ''
					}}
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
const { VUE_APP_ENV } = process.env
export default {
	data() {
		return {
			appEnv: VUE_APP_ENV
		}
	}
}
</script>
